import {atom} from "recoil";

export const AuthAtom = atom({
    key: "AuthAtom",
    default: false,
});